export default "__VITE_ASSET__BEFTMSRb__"